import { TokenStorageKeys } from '@/lib/auth/types';
import { CookieStorage } from '@/lib/storage';

export const tokenStorage = new CookieStorage();

// One-time cleanup for the `authenticatedUser` cookie that used to store the full user +
// membership object with a 365-day expiry. It's no longer written (kept in memory, rehydrated
// via `user/me`), but browsers that already have it stored need it purged once to unblock
// the "Cookie Too Large" errors it was causing. Guarded so we don't touch cookies on every load.
const LEGACY_COOKIE_CLEANUP_FLAG = 'cookieCleanupV1';

try {
  if (!localStorage.getItem(LEGACY_COOKIE_CLEANUP_FLAG)) {
    tokenStorage.removeItem(TokenStorageKeys.AUTHENTICATED_USER);
    localStorage.setItem(LEGACY_COOKIE_CLEANUP_FLAG, '1');
  }
} catch {
  // localStorage can be unavailable (e.g. privacy mode) - cleanup is a nice-to-have, not critical.
}
